import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import GeneralForm from '../../../components/generalForm';
import CustomSelect from '../../../components/customFields/customSelect';
import VEHICLE_TYPE from '../../../components/constants/vehicleType';
import { useVehicleEdit } from '../apiHooks';
import utils from '../../../utils/utils';
import forms from '../../../utils/forms';

function VehicleForm({ intl, vehicle, onSuccess }) {
  const [formVehicle, setFormVehicle] = useState(vehicle);

  const {
    editVehicle,
    isLoading: loading,
    isError: isError,
    error: vehicleEditError,
  } = useVehicleEdit((resultVehicle) => onSuccess(resultVehicle));

  const vehicleTypeOptions = Object.keys(VEHICLE_TYPE).map((key) => {
    const type = VEHICLE_TYPE[key];
    return {
      value: type.id,
      label: intl.formatMessage({ id: `admin.vehicle.types.${type.id}` }),
    };
  });

  const routingProfileOptions = forms.getRoutingProfiles();

  const formSchema = {
    type: 'object',
    required: [],
    properties: {
      vehicleId: {
        type: 'string',
        title: intl.formatMessage({ id: 'vehicle.form.field.vehicle.id.label' }),
      },
      vehicleType: {
        type: 'string',
        title: intl.formatMessage({ id: 'vehicle.form.field.type.label' }),
        options: vehicleTypeOptions,
      },
      count: {
        type: 'number',
        title: intl.formatMessage({ id: 'vehicle.form.field.count.label' }),
      },
      capacity: {
        type: 'number',
        title: intl.formatMessage({ id: 'vehicle.form.field.capacity.label' }),
      },
      maxTravelTimeInMinutes: {
        type: 'number',
        title: intl.formatMessage({ id: 'vehicle.form.field.max.travel.time.label' }),
      },
      maxLateTimeInMinutes: {
        type: 'number',
        title: intl.formatMessage({ id: 'vehicle.form.field.max.late.time.label' }),
      },
      routingProfileName: {
        type: 'string',
        title: intl.formatMessage({ id: 'vehicle.form.field.routing.profile.name.label' }),
        options: routingProfileOptions,
        showClearOption: true,
      },
    },
  };

  const uiSchema = {
    vehicleType: {
      'ui:field': 'customSelect',
    },
    routingProfileName: {
      'ui:field': 'customSelect',
    },
  };

  const onFormSubmit = () => {
    try {
      editVehicle({ vehicle: formVehicle });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  };

  const formFields = {
    customSelect: CustomSelect,
  };

  const buttonCopy = 'vehicle.edit.form.submit';

  return (
    <div>
      <GeneralForm
        onChange={(event) => setFormVehicle(event.formData)}
        onSubmit={onFormSubmit}
        formSchema={formSchema}
        formUiSchema={uiSchema}
        formFields={formFields}
        formData={formVehicle}
        buttonCopy={buttonCopy}
        errorMessage={isError ? utils.getErrorMessageFromResponse(vehicleEditError, true) : null}
        loading={loading}
        hideImageUpload={true}
      />
    </div>
  );
}

VehicleForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

VehicleForm.defaultProps = {
  onSuccess: () => {},
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

const mapDispatchToProps = {};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(VehicleForm));
